import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  TableHead,
  Stack,
} from "@mui/material";
import MDBadgeDot from "components/MDBadgeDot";
import { generateColorFromString } from "utils/GenerateColorFromString/GenerateColorFromString";
import TooltipLight from "utils/TooltipLight";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PopperWithHtml from "utils/PopperWithHtml";
import MDButton from "components/MDButton";
import { useTheme } from "@mui/material/styles";

const prefix = process.env.REACT_APP_CDN_ASSET_PREFIX || "/assets";
const badgeImage = `${prefix}/images/badges/Gold.svg`;

function KpiDetailsTable({ activitiesWithPoints, isMobileDisplay }) {
  const theme = useTheme();

  return (
    <Box>
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: "100%",
          userSelect: "none",
          overflowY: "auto",
          position: "relative",
          boxShadow: "none",
          borderRadius: 0,
        }}
      >
        <Table aria-label="simple table">
          {!isMobileDisplay && (
            <TableHead sx={{ display: "table-header-group" }}>
              <TableRow>
                <TableCell
                  sx={{
                    padding: "0.1rem .6rem",
                    margin: "0",
                    width: "1em",
                  }}
                />
                <TableCell
                  width="100%"
                  sx={{
                    padding: "0.75rem .6rem",
                  }}
                >
                  KPI
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    padding: "0.4rem .5rem",
                  }}
                >
                  KPIs Completed
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    padding: "0.4rem .6rem",
                  }}
                >
                  Points Achieved
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    whiteSpace: "nowrap",
                    padding: "0.4rem .6rem",
                  }}
                >
                  Daily Point Limit
                </TableCell>
              </TableRow>
            </TableHead>
          )}
          <TableBody>
            {activitiesWithPoints?.map((kpi) => (
              <TableRow key={kpi.id}>
                <TableCell
                  sx={{
                    padding: "0.1rem 0",
                    margin: "0",
                    width: "1em",
                  }}
                >
                  {kpi?.KpiActivity?.isSynced &&
                    (Array.isArray(kpi?.KpiActivity?.isSyncedTooltip) ? (
                      <PopperWithHtml data={kpi.KpiActivity.isSyncedTooltip} attachBackdropToBody>
                        <MDButton
                          sx={{
                            cursor: "pointer",
                            minHeight: "unset",
                            minWidth: "unset",
                            width: "1rem",
                            height: "2rem",
                            mb: "-0.15rem",
                            "&:hover": {
                              background: `${theme.palette.gray40.main}10`,
                            },
                          }}
                        >
                          <ArrowForwardIcon fontSize="small" sx={{ color: "#9ca4b1" }} />
                        </MDButton>
                      </PopperWithHtml>
                    ) : (
                      <TooltipLight
                        title={kpi?.KpiActivity.isSyncedTooltip}
                        placement="bottom"
                        variant="outline"
                      >
                        <ArrowForwardIcon fontSize="small" sx={{ color: "#9ca4b1" }} />
                      </TooltipLight>
                    ))}
                </TableCell>
                {isMobileDisplay ? (
                  <TableCell
                    sx={{
                      padding: "0.4rem .6rem",
                      margin: "0",
                      width: "100%",
                      display: "flex",
                    }}
                  >
                    <Grid container direction="column">
                      <Grid item display="flex">
                        <Stack direction="row" justifyContent="space-between" width="100%">
                          <Box display="flex">
                            <MDBadgeDot
                              size="lg"
                              sx={{
                                ml: 1,
                                p: 0,
                                i: {
                                  background: generateColorFromString(kpi?.KpiActivity?.name),
                                },
                              }}
                            />
                            {kpi?.KpiActivity?.name}
                          </Box>
                          {kpi?.KpiActivity?.isTrackingForBadge && (
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <img src={badgeImage} alt="badge" width={24} height={24} />
                            </Box>
                          )}
                        </Stack>
                      </Grid>
                      <Grid item pl={3}>
                        <Typography sx={{ fontSize: "1rem" }}>{`${kpi?.count} ${
                          kpi?.count && kpi.count === 1 ? "kpi" : "kpis"
                        } : ${kpi?.points} ${
                          kpi?.points && kpi.points === 1 ? "point" : "points"
                        }`}</Typography>
                      </Grid>
                    </Grid>
                  </TableCell>
                ) : (
                  <>
                    <TableCell
                      sx={{
                        padding: "0.4rem .6rem",
                        margin: "0",
                        width: "100%",
                        display: "flex",
                      }}
                    >
                      <Stack direction="row" justifyContent="space-between" width="100%">
                        <Box display="flex">
                          <MDBadgeDot
                            size="lg"
                            sx={{
                              ml: 1,
                              p: 0,
                              i: {
                                background: generateColorFromString(kpi?.KpiActivity?.name),
                              },
                            }}
                          />
                          {kpi?.KpiActivity?.name}
                        </Box>
                        {kpi?.KpiActivity?.isTrackingForBadge && (
                          <TooltipLight title="Track this KPI to earn badges!" placement="right">
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <img src={badgeImage} alt="badge" width={24} height={24} />
                            </Box>
                          </TooltipLight>
                        )}
                      </Stack>
                    </TableCell>
                    <TableCell sx={{ padding: "0.4rem .3rem", width: "8%" }} align="center">
                      {kpi?.count}
                    </TableCell>
                    <TableCell sx={{ padding: "0.4rem .3rem", width: "8%" }} align="center">
                      {kpi?.points}
                    </TableCell>
                    <TableCell
                      sx={{ padding: "0.4rem .3rem", width: "8%", fontWeight: "bold" }}
                      align="center"
                    >
                      {kpi?.max_points_per_day}
                    </TableCell>
                  </>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default KpiDetailsTable;
